import {
  verifastSummaryStatusBadgeVariant,
  type VerifastSummaryBadgeVariant,
} from "./verifastLogsMapper";

export type VerifastStatusBadgeVariant = VerifastSummaryBadgeVariant | "info";

export const VERIFAST_STATUS_BADGE_CLASS: Record<VerifastStatusBadgeVariant, string> = {
  complete:
    "inline-flex items-center rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-semibold text-emerald-800 ring-1 ring-inset ring-emerald-200",
  failed:
    "inline-flex items-center rounded-full bg-rose-50 px-2.5 py-0.5 text-xs font-semibold text-rose-800 ring-1 ring-inset ring-rose-200",
  neutral:
    "inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-200",
  info: "inline-flex items-center rounded-full bg-sky-50 px-2.5 py-0.5 text-xs font-semibold text-sky-800 ring-1 ring-inset ring-sky-200",
};

function normalizeVerifastStatusToken(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, "_");
}

/** About Yourself ID Verification — treat review/failure states as red (failed variant). */
function isRedVerifastIdentityStatus(normalizedKey: string): boolean {
  return (
    normalizedKey === "failed" ||
    normalizedKey === "rejected" ||
    normalizedKey === "expired" ||
    normalizedKey === "needs_review" ||
    normalizedKey === "awaiting_review" ||
    normalizedKey === "pending_review"
  );
}

export function verifastFieldBadgeVariant(
  raw: unknown,
  formattedLabel: string,
  field: "id" | "completion" | "approval" | "document",
): VerifastStatusBadgeVariant {
  if (field === "document") {
    if (!formattedLabel || formattedLabel === "—") return "neutral";
    return "info";
  }

  const source =
    raw !== undefined && raw !== null && String(raw).trim() !== ""
      ? String(raw).trim()
      : formattedLabel.trim();

  if (!source || source === "—") return "neutral";

  const normalized = normalizeVerifastStatusToken(source);
  if (normalized === "pending") return "neutral";

  if (field === "id" || field === "approval" || field === "completion") {
    if (isRedVerifastIdentityStatus(normalized)) return "failed";
  }

  return verifastSummaryStatusBadgeVariant(source);
}
